import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, Crown, Sparkles, Trophy, Users } from 'lucide-react';

function Home() {
  return (
    <div className="home-page">
      <section className="home-hero">
        <div className="content-width hero-grid">
          <div className="hero-copy">
            <div className="eyebrow"><Sparkles size={17} aria-hidden="true" /> For the people</div>
            <h1>The Pepes<br />Community Board</h1>
            <p>Track the collectors, points, and people behind the first 10,000 recursive Pepes on Bitcoin.</p>
            <div className="hero-actions">
              <Link to="/leaderboards" className="button button-primary">
                View leaderboard <ArrowRight size={19} aria-hidden="true" />
              </Link>
              <Link to="/holders" className="button button-secondary">
                Explore holders <Users size={19} aria-hidden="true" />
              </Link>
            </div>
          </div>
          <div className="hero-art" aria-hidden="true">
            <img src="/pepes-community-hero.png" alt="" />
          </div>
        </div>
      </section>

      <section className="collection-strip" aria-label="Collection highlights">
        <div className="content-width collection-facts">
          <div><strong>10,000</strong><span>Original Pepes</span></div>
          <div><strong>2x</strong><span>Daily points per Pepe</span></div>
          <div><strong>Bitcoin</strong><span>Recursive Ordinals</span></div>
        </div>
      </section>

      <section className="community-links content-width">
        <div className="section-heading">
          <div className="eyebrow eyebrow-dark"><Crown size={17} aria-hidden="true" /> Community tools</div>
          <h2>Find your place in the collection.</h2>
        </div>
        <div className="feature-grid">
          <Link to="/leaderboards" className="feature-card feature-card-yellow">
            <Trophy aria-hidden="true" />
            <span className="feature-number">01</span>
            <h3>Points leaderboard</h3>
            <p>Follow the daily race and search any holder wallet.</p>
            <span className="feature-link">See the rankings <ArrowRight size={18} aria-hidden="true" /></span>
          </Link>
          <Link to="/holders" className="feature-card feature-card-light">
            <Users aria-hidden="true" />
            <span className="feature-number">02</span>
            <h3>Top holders</h3>
            <p>See the biggest collectors and their share of the supply.</p>
            <span className="feature-link">Meet the collectors <ArrowRight size={18} aria-hidden="true" /></span>
          </Link>
          <div className="feature-card feature-card-dark" aria-disabled="true">
            <BookOpen aria-hidden="true" />
            <span className="feature-number">03</span>
            <h3>Community stories</h3>
            <p>Holder news, collection lore, and new stories are coming soon.</p>
            <span className="feature-link">Coming soon</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
